import { patchRequest } from '../base_requests';

export function saveTopicGoalRequest(topicGoalId, body) {
  return patchRequest({ url: `/customer/api/action_plan_topic_goals/${topicGoalId}`, body, asJson: false})
}

export function saveInitialTopicGoalRequest(topicGoalId, body) {
  return patchRequest({ url: `/customer/api/action_plan_topic_goals/${topicGoalId}/update_initial`, body})
}